import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import MetaInfo from 'vue-meta-info'
Vue.use(MetaInfo)

Vue.prototype.$bus = new Vue();
Vue.use(ElementUI)
Vue.use(Antd);
Vue.prototype.$antdconfirm = Vue.prototype.$confirm

//bus总线 非父子间传值
Vue.prototype.$bus = new Vue();

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
  mounted () {
    document.dispatchEvent(new Event('render-event'))
    }
}).$mount("#app");

